

export const routePath = {
  //blog routes
  notFound: "/not-found",
  forgotPassword: "/ForgotPassword",
  login: "/login",
  usersManagement: "/usersManagement",
  dashboard: "/dashboard",
  users: "/users",
  adminBlogs: "/adminBlogs",
  AddBlog: "/addBlog",
  userBlog: "/userBlog",
  ViewAdminBlog: "/viewBlog",
  editBlog: "/editBlog",
  addAdminNewsletter : "/addAdminNewsletter",
  adminNewsletter : "/adminNewsletter",
  AdminArticle:"/adminArticle",
  ViewArticle:"/viewArticle",
  editArticle:"/editArticle",
  editNewsletter : "/editNewsletter",
  viewNewsletter : "/viewNewsletter",
  newsLetterSubscriber : "/newsletterRegisteredEmail",
  userArticle:"/userArticle",
  ArticleForm:"/articleForm",
  UpdateReview : "/updateReview",
  Profile : "/profile",
  Technologies : "/technologies",


  //-- ChatBot routepath(old flask routes) --

  // chatBotDashboard: "/chatBotDashboard",
  // showSavedQdrantQa: "/showSavedQdrantQa",
  // show_DeletedQdrantQa : "/showDeletedQdrantQa",
  // userAgentChats: "/userAgentChats",
  // userBotChats: "/userBotChats",

  documents: "/documents",
  deletedDocuments: "/deletedDocuments",
  uploadPdf: "/uploadPdf",
  userAgentChats: "/showUserAgentChats",
  userBotChats: "/showUserBotChats",
  showClientDetectionEmails : "/showClientDetectionEmails",
  showFeatures:"/showFeatures",
  showNewDashboard:"/showChatBotDashboard",
  clientDetails:"/showClientDetails",
  systemLogs:"/systemLogs"
};
